module.exports = __webpack_public_path__ + "src/img/avatar-b.47684e94.png";